<template>
    <div>


        <b-modal id="login-modal" ref="login_modal" title="Пријава" @hide="prevent" dialog-class="pis-modal">

            <form ref="form" v-on:keyup.enter="handleLogin()">

                <b-form-group>

                    <label for="username-input">Корисничко име</label>
                    <b-form-input placeholder="Корисничко име" id="username-input" v-model="username"
                        required></b-form-input>
                </b-form-group>
                <b-form-group>
                    <label for="password-input">Лозинка</label>
                    <b-form-input placeholder="Лозинка" id="password-input" v-model="password" type="password"
                        required></b-form-input>
                </b-form-group>

            </form>
            <b-alert variant="danger" :show="errorMessage">{{ errorMessage }}</b-alert>

            <template v-slot:modal-footer class="d-block">
                <div class="btn-group-2-1">
                    <div class="div1">
                        <b-button class="modal-btn cancel-btn btn-block" variant="pis" @click="cancel()">
                            Одустани
                        </b-button>
                    </div>
                    <div class="div2">
                        <b-button class="modal-btn ok-btn btn-block" variant="pis" @click="handleLogin()">
                            Пријава
                        </b-button>
                    </div>
                    <div class="div3" v-if="promotion.length > 0">
                        <router-link class="modal-btn-outline register-btn btn-block" @click.native="closeLogin"
                            to="/promo">Регистрација за ПРОМО период
                        </router-link>
                    </div>

                </div>

            </template>
        </b-modal>

        <b-modal id="poll-modal" ref="poll_modal" title="Анкета" @hide="prevent">
            <form ref="form" @submit.stop.prevent="handleSubmit">
                <!--                <h3>Добро дошли!</h3>-->
                <p v-if="userType != 1"> <!-- OBICAN KORISNIK -->
                    Поштовани, <br>
                    Молимо Вас да, уколико сте заинтересовани, попуните анкету у циљу побољшања Вашег корисничког искуства и
                    унапређења квалитета Правно-информационог система Републике Србије.
                    <br>
                    Унапред хвала на Вашим одговорима.
                </p>
                <p v-else> <!-- PROMO -->
                    Поштовани, <br>
                    Уколико сте заинтересовани за додатних 15 дана ПРОМО приступа Правно-информационом систему Републике
                    Србије, молимо Вас да попуните анкету.
                    <br>
                    Унапред хвала на Вашим одговорима.
                </p>
            </form>

            <template v-slot:modal-footer>
                <b-button variant="default" v-if="userType !== 1" @click="delayPoll">Попуните касније</b-button>
                <!-- <a href="http://10.10.32.190/meganketa/index.php/357722?lang=sr" target="_blank" class="btn btn-info" @click="acceptPoll">Попуните анкету</a> -->
                <b-button variant="info" @click="acceptPoll">Попуните анкету</b-button>
                <b-button variant="danger" @click="askDeclinePoll">Одустани</b-button>
            </template>
        </b-modal>

        <b-modal id="poll-modal" ref="poll_decline_confirmation_modal" title="Анкета">

            <form ref="form" @submit.stop.prevent="handleSubmit">
                <p>Да ли сте сигурни да не желите да попуните анкету?</p>
                <p v-if="userType === 1">Приступ садржају ће вам бити онемогућен.</p>
            </form>
            <template v-slot:modal-footer>
                <b-button variant="danger" @click="declinePoll">Да</b-button>
                <b-button variant="info" @click="returnToPollModal">Не</b-button>
            </template>
        </b-modal>

        <b-modal hide-footer id="poll-frame-modal" ref="poll_frame_modal" title="Анкета" size="lg">
            <iframe :src="pollUrl" width="100%" height="600px"></iframe>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState } from 'vuex'


export default {
    name: "LoginModal",
    data() {
        return {
            loginApiUrl:window.env.VUE_APP_API_KCPROXY_DEV + 'proxy/login',
            pollApiUrl:window.env.VUE_APP_API_KCPROXY_DEV + 'proxy/GetUserPoll',
            pollDeclineApiUrl:window.env.VUE_APP_API_KCPROXY_DEV + 'proxy/DeclinePoll',
            baseApiUrl: window.env.VUE_APP_API_KCPROXY_DEV,
            username: null,
            password: null,
            errorMessage: null,
            pollUrl: null,
            declineUrl: null,
            userType: null,
            promotion: []
        }
    },
    methods: {
        ...mapActions([
            'setUserInfo',
        ]),
        cancel() {
            this.$refs['login_modal'].hide();
            this.errorMessage = null;
        },
        handleLogin() {
            var self = this;
            axios.post(this.loginApiUrl, {
                password: this.password,
                username: this.username
            })
                .then(response => {
                    self.errorMessage = null;
                    // console.log("response.status: ", response.data.status);
                    if (response.data.status === -2) {
                        // login nije uspeo
                        // Energosoft Vlada: -2 status je za prekoracenje broja dozvoljenih sesija
                        self.errorMessage = "Прекорачен је број максималних дозвољених сесија";
                    }
                    else if (response.data.status === -1) {
                        // login nije uspeo
                        // Energosoft Vlada: -1 status je za pogresno unesene kredencijale
                        self.errorMessage = "Унели сте погрешну лозинку или корисничко име";
                    } else {
                        console.log("before livezile windows")
                        // window.LiveZilla.SetData({
                        //     overwrite: true,
                        //     111: response.data.userInfo.userName,
                        //     112: response.data.userInfo.userName
                        // });
                        console.log("response.data: ", response.data);

                        self.$refs['login_modal'].hide();
                        console.log("after livezile windows")
                        // Internal user does not get poll offer.
                        if (response.data.userInfo.roles.indexOf('INTERNAL') !== -1) {
                            return;
                        }

                        axios.get(this.pollApiUrl)
                            .then(response => {
                                if (response.data.filloutPoll !== null) {
                                    this.pollUrl = response.data.filloutPoll;
                                    this.declineUrl = response.data.decline;
                                    this.userType = response.data.userType;
                                    this.$refs['poll_modal'].show();
                                }
                            });

                        // Check for partitions - roles
                        // -----------------------------------------------------------------------------------------
                        const vm = self;
                        axios.post(self.baseApiUrl + 'proxy/info')
                            .then(function (response) {
                                if (response.status === 204) {
                                    // not logged in;  204
                                } else {
                                    let userData = response.data;

                                    if (userData.roles.includes("INTERNAL_USER")) {
                                        userData.roles = ["**", "NP", "INTERNAL_USER", "SGARHSTARO", "PGARHSTARO", "REG", "PG2010", "NEWS", "WPP_ESZLJP_GUIDE", "WPP_KD", "LSD", "SP", "SLARHSTARO", "MUARHSTARO", "MUTG", "BGP"];
                                    }
                                    vm.setUserInfo(userData);
                                }
                            })
                            .catch(function (error) {     // handle error

                                console.log(error);
                            })
                            .finally(function () {
                                // always executed                                
                            });
                        // -----------------------------------------------------------------------------------------
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.data.status === -2) {
                        // login nije uspeo
                        // Energosoft Vlada: -2 status je za prekoracenje broja dozvoljenih sesija
                        self.errorMessage = "Прекорачен је број максималних дозвољених сесија";
                    }
                    else if (error.response.data.status === -1) {
                        // login nije uspeo
                        // Energosoft Vlada: -1 status je za pogresno unesene kredencijale
                        self.errorMessage = "Унели сте погрешну лозинку или корисничко име";
                    } else {
                        self.errorMessage = "Дошло је до неочекиване грешке";
                    }
                });
        },
        delayPoll: function () {
            this.$refs['poll_modal'].hide();
        },
        acceptPoll: function () {
            this.$refs['poll_modal'].hide();
            this.$refs['poll_frame_modal'].show();
        },
        declinePoll: function () {
            this.$refs['poll_decline_confirmation_modal'].hide();
            this.$refs['poll_modal'].hide();

            axios.post(this.pollDeclineApiUrl, {
                declinePollLink: this.declineUrl
            })
        },
        askDeclinePoll: function () {
            this.$refs['poll_decline_confirmation_modal'].show();
        },
        returnToPollModal: function () {
            this.$refs['poll_decline_confirmation_modal'].hide();
        },
        closeLogin: function () {
            this.$refs['login_modal'].hide();
        },
        prevent: function (event) {
            if (this.userType === 1) {
                if (event.trigger === 'backdrop') {
                    event.preventDefault();
                } else if (event.trigger === 'headerclose') {
                    event.preventDefault();
                    this.askDeclinePoll();
                }
            }
        }
    },
    computed: {
        ...mapState([
            'userInfoState'
        ])
    },
    mounted() {
        // added aleksandar endpoint for check promotion
        axios.get(this.baseApiUrl + 'proxy/GetPromoActivation')
            .then(res => {
                this.promotion = res.data
            })
        this.$root.$on("bv::modal::hide", () => {
            this.errorMessage = null;
        })
    }
}
</script>

<style>
.modal-footer {
    -ms-flex-pack: justify;
    justify-content: space-between;
}

.modal-backdrop {
    background-color: rgba(0, 0, 0, 0.75);
}
</style>
